/* mod-scripts.js - skrypty modulow mod-*: karuzela, licznik promocji, karta produktu (zestawy, cena, sticky) */
(function () {
  'use strict';
  if (window.__modScriptsLoaded) return;
  window.__modScriptsLoaded = true;

  /* ---------- Karuzela: scroll-snap + strzalki + kropki/miniatury ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    var gotos = Array.prototype.slice.call(root.querySelectorAll('[data-goto]'));
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var thumbsWrap = root.querySelector('[data-thumbs]');
    var loop = root.hasAttribute('data-loop');
    var current = 0;

    function isAtEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function update() {
      var x = track.scrollLeft, best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      current = best;
      gotos.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-goto'), 10);
        var active = idx === current;
        g.classList.toggle('is-active', active);
        if (active) { g.setAttribute('aria-current', 'true'); } else { g.removeAttribute('aria-current'); }
        if (active && thumbsWrap && thumbsWrap.contains(g)) {
          var left = g.offsetLeft - thumbsWrap.clientWidth / 2 + g.clientWidth / 2;
          thumbsWrap.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
      if (prev) prev.disabled = !loop && current === 0;
      if (next) next.disabled = !loop && (current === slides.length - 1 || isAtEnd());
    }
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    gotos.forEach(function (g) {
      g.addEventListener('click', function () { goTo(parseInt(g.getAttribute('data-goto'), 10)); });
    });
    if (prev) prev.addEventListener('click', function () {
      if (current <= 0) { if (loop) goTo(slides.length - 1); return; }
      goTo(current - 1);
    });
    if (next) next.addEventListener('click', function () {
      if (current >= slides.length - 1 || isAtEnd()) { if (loop) goTo(0); return; }
      goTo(current + 1);
    });
    root.addEventListener('mod:goto', function (e) { goTo(e.detail, true); });
    window.addEventListener('resize', update);
    var start = parseInt(root.getAttribute('data-start') || '0', 10);
    if (start > 0) goTo(start, true);
    update();
  }

  /* ---------- Licznik promocji ---------- */
  function initCountdown(root) {
    var out = {
      d: root.querySelector('[data-cd-d]'),
      h: root.querySelector('[data-cd-h]'),
      m: root.querySelector('[data-cd-m]'),
      s: root.querySelector('[data-cd-s]')
    };
    if (!out.d || !out.h || !out.m || !out.s) return;
    function endOfMonth() {
      var n = new Date();
      return new Date(n.getFullYear(), n.getMonth() + 1, 0, 23, 59, 59);
    }
    function parseEnd(raw) {
      if (!raw) return null;
      var t = raw.replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}$/.test(t)) t += 'T23:59:59';
      var d = new Date(t);
      return isNaN(d.getTime()) ? null : d;
    }
    var end = parseEnd((root.getAttribute('data-end') || '').trim());
    if (!end || end.getTime() < Date.now()) end = endOfMonth();
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end.getTime() - Date.now());
      out.d.textContent = pad(Math.floor(diff / 864e5));
      out.h.textContent = pad(Math.floor(diff / 36e5) % 24);
      out.m.textContent = pad(Math.floor(diff / 6e4) % 60);
      out.s.textContent = pad(Math.floor(diff / 1e3) % 60);
      if (diff === 0) end = endOfMonth();
    }
    tick();
    if (root.__modTimer) clearInterval(root.__modTimer);
    root.__modTimer = setInterval(tick, 1000);
  }

  /* ---------- Karta produktu: wybor zestawu, cena, galeria, sticky ---------- */
  function initProduct(root) {
    var formId = root.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var bundle = root.querySelector('[data-mod-bundle]');
    var gallery = root.querySelector('[data-mod-carousel]');
    var els = {
      current: root.querySelectorAll('[data-price-current]'),
      compare: root.querySelectorAll('[data-price-compare]'),
      save: root.querySelectorAll('[data-price-save]'),
      lowest: root.querySelectorAll('[data-price-lowest]')
    };

    function setAll(list, text, hideWhenEmpty) {
      Array.prototype.forEach.call(list, function (el) {
        if (hideWhenEmpty) el.hidden = !text;
        if (text || !hideWhenEmpty) el.textContent = text || '';
      });
    }
    function apply(radio) {
      if (!radio) return;
      if (idInput) { idInput.value = radio.value; idInput.disabled = false; }
      setAll(els.current, radio.getAttribute('data-price'));
      setAll(els.compare, radio.getAttribute('data-compare'), true);
      setAll(els.save, radio.getAttribute('data-save'), true);
      setAll(els.lowest, radio.getAttribute('data-lowest'));
      if (bundle) {
        Array.prototype.forEach.call(bundle.querySelectorAll('.mod-bundle__tile'), function (t) {
          t.classList.toggle('is-selected', t.contains(radio));
        });
      }
      var url = radio.getAttribute('data-url');
      if (url && window.history && history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
        history.replaceState({}, '', url);
      }
      var mediaId = radio.getAttribute('data-media-id');
      if (gallery && mediaId) {
        var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
        if (slide) gallery.dispatchEvent(new CustomEvent('mod:goto', { detail: parseInt(slide.getAttribute('data-index'), 10) }));
      }
    }
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input[type="radio"]')) apply(e.target);
      });
      var checked = bundle.querySelector('input[type="radio"]:checked');
      if (checked && idInput && idInput.value !== checked.value) apply(checked);
    }

    var sticky = root.querySelector('[data-mod-sticky]');
    var anchor = root.querySelector('[data-sticky-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var scrolledPast = en.boundingClientRect.bottom < 0;
        sticky.hidden = en.isIntersecting || !scrolledPast;
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }

  /* ---------- Karteczka do prezentu: 1 lub 2 karteczki, podglad-karuzela, walidacja ---------- */
  function initGiftCard(root) {
    var formId = root.getAttribute('data-form');
    var product = root.closest('[data-mod-product]');
    var bundle = product ? product.querySelector('[data-mod-bundle]') : null;
    var all = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var tiles = all('[data-choice]');
    if (!tiles.length) return;
    var choices = all('[data-gift-choice]');
    var groups = all('[data-gift-custom]');
    var texts = groups.map(function (g) { return g.querySelector('textarea'); });
    var sign = root.querySelector('[data-gift-sign]');
    var track = root.querySelector('[data-gift-track]');
    var slides = all('[data-gift-slide]');
    var dots = all('[data-gift-dot]');
    var prevBtn = root.querySelector('[data-gift-prev]');
    var nextBtn = root.querySelector('[data-gift-next]');
    var placeholder = texts[0] ? texts[0].getAttribute('placeholder') : '';
    var state = { count: 1, slots: [tiles[0], tiles[0]], next: 0 };
    var ignoreScrollUntil = 0;

    function bundleCount() {
      var r = bundle ? bundle.querySelector('input[type="radio"]:checked') : null;
      var c = r ? parseInt(r.getAttribute('data-count') || '1', 10) : 1;
      return c >= 2 ? 2 : 1;
    }
    function isCustom(tile) { return tile.hasAttribute('data-custom'); }
    function slideLeft(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
    function visible() {
      if (state.count < 2) return 0;
      var x = track.scrollLeft;
      return Math.abs(x - slideLeft(1)) < Math.abs(x - slideLeft(0)) ? 1 : 0;
    }
    function goTo(i, instant) {
      if (state.count < 2) i = 0;
      ignoreScrollUntil = Date.now() + 700;
      track.scrollTo({ left: slideLeft(i), behavior: instant ? 'auto' : 'smooth' });
      updateNav(i);
    }
    function updateNav(i) {
      var two = state.count === 2;
      if (i === undefined) i = visible();
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prevBtn) prevBtn.hidden = !two || i === 0;
      if (nextBtn) nextBtn.hidden = !two || i === 1;
    }
    function setError(k, on) {
      var e = groups[k].querySelector('[data-gift-error]');
      if (e) e.hidden = !on;
      texts[k].classList.toggle('is-invalid', on);
    }
    function render() {
      var two = state.count === 2;
      root.classList.toggle('is-double', two);
      tiles.forEach(function (t) {
        var nums = [];
        for (var k = 0; k < state.count; k++) if (state.slots[k] === t) nums.push(k + 1);
        t.classList.toggle('is-selected', nums.length > 0);
        t.setAttribute('aria-pressed', nums.length > 0 ? 'true' : 'false');
        var badge = t.querySelector('[data-gift-slots]');
        if (badge) {
          badge.textContent = nums.join(' i ');
          badge.hidden = !two || !nums.length;
        }
      });
      var signed = sign ? sign.value.trim() : '';
      for (var k = 0; k < 2; k++) {
        var active = k < state.count;
        var tile = state.slots[k];
        var custom = active && isCustom(tile);
        var suffix = two ? ' ' + (k + 1) : '';
        choices[k].disabled = !active;
        choices[k].name = 'properties[Karteczka' + suffix + ']';
        choices[k].value = tile.getAttribute('data-label') || '';
        groups[k].hidden = !custom;
        texts[k].disabled = !custom;
        texts[k].name = 'properties[Życzenia' + suffix + ']';
        if (!custom) setError(k, false);
        var num = groups[k].querySelector('[data-gift-num]');
        if (num) num.textContent = two ? ' – karteczka ' + (k + 1) : '';
        var cnt = groups[k].querySelector('[data-gift-count]');
        if (cnt) cnt.textContent = texts[k].value.length;
        var s = slides[k];
        s.hidden = !active;
        var h = s.querySelector('[data-gift-heading]');
        var p = s.querySelector('[data-gift-preview]');
        var sg = s.querySelector('[data-gift-sign-preview]');
        if (custom) {
          var v = texts[k].value.trim();
          h.textContent = '';
          p.textContent = v || placeholder;
          p.classList.toggle('is-placeholder', !v);
        } else {
          h.textContent = tile.getAttribute('data-heading') || '';
          p.textContent = tile.getAttribute('data-text') || '';
          p.classList.remove('is-placeholder');
        }
        sg.textContent = signed || sg.getAttribute('data-default') || '';
        sg.classList.toggle('is-placeholder', !signed);
      }
      updateNav();
    }
    /* Delikatne "szturchniecie" karuzeli, zeby bylo widac, ze jest druga karteczka */
    function nudge() {
      if (state.count < 2 || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
      ignoreScrollUntil = Date.now() + 1200;
      track.scrollTo({ left: 70, behavior: 'smooth' });
      setTimeout(function () { track.scrollTo({ left: 0, behavior: 'smooth' }); }, 450);
    }
    function syncCount() {
      var c = bundleCount();
      if (c === state.count) return;
      state.count = c;
      if (c === 2) { state.slots[1] = state.slots[0]; state.next = 1; }
      else { state.next = 0; }
      render();
      goTo(0, true);
      if (c === 2) setTimeout(nudge, 150);
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = state.count === 2 ? state.next : 0;
        state.slots[k] = t;
        if (state.count === 2) state.next = k === 0 ? 1 : 0;
        render();
        if (state.count === 2) goTo(k);
      });
    });
    texts.forEach(function (ta, k) {
      ta.addEventListener('focus', function () { if (state.count === 2) goTo(k); });
      ta.addEventListener('input', function () { if (ta.value.trim()) setError(k, false); render(); });
    });
    if (sign) sign.addEventListener('input', render);
    dots.forEach(function (d, n) { d.addEventListener('click', function () { state.next = n; goTo(n); }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { state.next = 0; goTo(0); });
    if (nextBtn) nextBtn.addEventListener('click', function () { state.next = 1; goTo(1); });
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = visible();
        if (Date.now() > ignoreScrollUntil) state.next = i;
        updateNav(i);
      }, 120);
    }, { passive: true });
    if (bundle) bundle.addEventListener('change', syncCount);

    /* Faza capture: blokujemy wyslanie formularza (tez z paska sticky), gdy wlasne zyczenia sa puste */
    document.addEventListener('submit', function (e) {
      /* getAttribute: form.id zwraca input name="id" (wariant), nie atrybut formularza */
      if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== formId) return;
      for (var k = 0; k < state.count; k++) {
        if (isCustom(state.slots[k]) && !texts[k].value.trim()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          setError(k, true);
          goTo(k);
          texts[k].scrollIntoView({ behavior: 'smooth', block: 'center' });
          texts[k].focus({ preventScroll: true });
          return;
        }
      }
    }, true);

    state.count = bundleCount();
    if (state.count === 2) state.next = 1;
    render();
    if (state.count === 2) setTimeout(nudge, 600);
  }

  /* ---------- Zakladki z mediami ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    if (!tabs.length) return;
    function activate(i) {
      i = String(i);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-panel') === i;
        p.hidden = !on;
        if (on) {
          var v = p.querySelector('video');
          if (v && v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        }
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-tab')); });
    });
    root.__modActivate = activate;
  }

  function initAll(scope) {
    scope = scope || document;
    function q(sel, fn) {
      Array.prototype.forEach.call(scope.querySelectorAll(sel), function (el) {
        if (el.__modInit) return;
        el.__modInit = true;
        fn(el);
      });
    }
    q('[data-mod-carousel]', initCarousel);
    q('[data-mod-countdown]', initCountdown);
    q('[data-mod-product]', initProduct);
    q('[data-mod-tabs]', initTabs);
    q('[data-mod-gift]', initGiftCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('[data-tab]') : null;
    var root = tab ? tab.closest('[data-mod-tabs]') : null;
    if (root && root.__modActivate) root.__modActivate(tab.getAttribute('data-tab'));
  });
})();